import { g as getComponentProps } from "./resolve-component-props-6be1f787.mjs";
function extractComponentProps(component, ignoreProps) {
  const props = getComponentProps(component);
  if (ignoreProps) {
    return Object.keys(props).reduce((acc, propName) => {
      if (ignoreProps.includes(propName)) {
        return acc;
      }
      if (props[propName] === void 0) {
        return acc;
      }
      acc[propName] = typeof props[propName] === "string" ? {} : props[propName];
      return acc;
    }, {});
  }
  return props;
}
function extractComponentEmits(component) {
  return [...new Set(component.emits)];
}
export {
  extractComponentEmits as a,
  extractComponentProps as e
};
//# sourceMappingURL=extract-component-options-6b96d215.mjs.map
